var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sqs"},[_c('el-button',{on:{"click":_vm.handleUpload}},[_vm._v("下载授权书")]),_c('el-button',{attrs:{"loading":_vm.loading,"type":"primary"},on:{"click":_vm.handleSend}},[_vm._v("发送授权书\n  ")]),_vm._m(0),_c('auth',{ref:"auth",on:{"submit":_vm.getList}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('canvas',{attrs:{"id":"canvas","width":"1000","height":"1365"}})])
}]

export { render, staticRenderFns }